import { CircularProgress } from "@mui/material";
import wifiImage from "../../assets/wifi.png";
import Button from "../../Components/Button";
import React, { useState } from "react";

const NoInternet = () => {
  const [reloading, setReloading] = useState(false);

  const checkInternetConnection = () => !navigator.onLine;

  const checkHotspotConnection = () => {
    const hotspotOn = true; // This could be your actual logic to check hotspot connection
    return hotspotOn;
  };

  const reloadPage = () => {
    setReloading(true);
    const internetConnectionIssue = checkInternetConnection();
    const hotspotConnectionIssue = checkHotspotConnection();

    const reloadTimeout =
      internetConnectionIssue || hotspotConnectionIssue ? 5000 : 1000;

    setTimeout(() => {
      if (internetConnectionIssue || hotspotConnectionIssue) {
        setReloading(false);
      } else {
        window.location.reload();
      }
    }, reloadTimeout);
  };

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen bg-white">
      <div className="w-full sm:w-148 h-auto rounded-xl">
        <div className="mt-56 sm:mt-8 flex flex-col items-center justify-center text-center p-4">
          <div>
            <img
              src={wifiImage}
              alt="No Internet Connection"
              height="100px"
              width="100px"
            />
          </div>

          <div className="text-xl font-semibold mt-5">Oops! No Connection</div>

          <div className="text-center mt-2">
            Seems like we hit a bump. Please check your connection and click
            'Reconnect Now' to get back on track. Thanks for your patience!
          </div>
        </div>

        <div className="flex flex-col items-center sm:w-full justify-center absolute inset-x-0 bottom-0 sm:relative p-4">
          <Button
            className="w-full bg-[#0947AB] text-white"
            onClick={reloadPage}
            disabled={reloading}
          >
            {reloading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Reconnect now"
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NoInternet;
